export type LimpezaStatus = "pendente" | "agendada" | "concluida";

export const LIMPEZA_STATUS_LABELS: Record<LimpezaStatus, string> = {
  pendente: "Pendente",
  agendada: "Agendada",
  concluida: "Concluída",
};

export function getLimpezaStatusBadgeClass(status?: LimpezaStatus | null): string {
  switch (status) {
    case "agendada":
      return "bg-blue-100 text-blue-800";
    case "concluida":
      return "bg-green-100 text-green-800";
    case "pendente":
    default:
      return "bg-yellow-100 text-yellow-800";
  }
}

/** Plano inclui limpeza (flag no banco ou nome do plano). */
export function planoIncluiLimpeza(
  plano?: { inclui_limpeza?: boolean | null; nome?: string | null } | null
): boolean {
  if (!plano) return false;
  if (plano.inclui_limpeza === true) return true;
  const nome = (plano.nome || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return nome.includes("limpeza") && nome.includes("protecao");
}

/** Bucket privado do Supabase Storage com os modelos de contrato. */
export const CONTRATO_TEMPLATES_BUCKET = "contratos-templates";
export const CONTRATO_PDF_NORMAL = "CONTRATO_SERVICO_SUNPRO.pdf";
export const CONTRATO_PDF_LIMPEZA = "CONTRATO_SERVICO_SUNPRO_LIMPEZA.pdf";

export function resolverTemplateContrato(
  plano?: { inclui_limpeza?: boolean | null; nome?: string | null } | null
): string {
  return planoIncluiLimpeza(plano) ? CONTRATO_PDF_LIMPEZA : CONTRATO_PDF_NORMAL;
}
